import { appendQueryString } from "../../../api/appendQueryString";
import type { Api } from "../../../api/subApis/api.types";

const startPageApi = {
  sites: {
    url: (projectId?: string) =>
      appendQueryString("/api/start-page/sites/", {
        project_id: projectId
      }),
    key: (projectId?: string) => ["startPage", "sites", { projectId }]
  },
  onboardingProgress: {
    url: (params?: {
      page: number;
      pageSize: number;
      projectId?: string;
      siteId?: number;
    }) => {
      const { page, pageSize, projectId, siteId } = params ?? {};
      return appendQueryString("/api/start-page/onboarding-progress/", {
        page,
        page_size: pageSize,
        project_id: projectId,
        site_id: siteId
      });
    },
    key: (params?: {
      page: number;
      pageSize: number;
      projectId?: string;
      siteId?: number;
    }) => {
      const { page, pageSize, projectId, siteId } = params ?? {};
      return [
        "startPage",
        "onboardingProcess",
        { page, pageSize, projectId, siteId }
      ];
    }
  },
  companies: {
    url: (projectId?: string) =>
      appendQueryString("/api/start-page/companies/", {
        project_id: projectId
      }),
    key: (projectId?: string) => ["startPage", "companies", { projectId }]
  },
  regulatoryTodos: {
    url: (params?: {
      page: number;
      pageSize: number;
      projectId?: string;
      companyId?: number;
    }) => {
      const { page, pageSize, projectId, companyId } = params ?? {};
      return appendQueryString("/api/start-page/regulatory-todos/", {
        page,
        page_size: pageSize,
        project_id: projectId,
        company_id: companyId
      });
    },
    key: (params?: {
      page?: number;
      pageSize?: number;
      projectId?: string;
      companyId?: number;
    }) => {
      const { page, pageSize, projectId, companyId } = params ?? {};
      return [
        "startPage",
        "regulatoryTodos",
        { page, pageSize, projectId, companyId }
      ];
    }
  },
  invoices: {
    url: (year: number, projectId?: string) =>
      appendQueryString("/api/start-page/invoices/", {
        project_id: projectId,
        year
      }),
    key: (year?: number, projectId?: string) => [
      "startPage",
      "invoices",
      { year, projectId }
    ]
  },
  co2Savings: {
    url: (year: number, projectId?: string) =>
      appendQueryString("/api/start-page/co2-savings/", {
        project_id: projectId,
        year
      }),
    key: (year?: number, projectId?: string) => [
      "startPage",
      "co2Savings",
      { year, projectId }
    ]
  },
  deliveredElectricity: {
    url: (year: number, projectId?: string) =>
      appendQueryString("/api/start-page/delivered-electricity/", {
        project_id: projectId,
        year
      }),
    key: (year?: number, projectId?: string) => [
      "startPage",
      "deliveredElectricity",
      { year, projectId }
    ]
  },
  producedElectricity: {
    url: (year: number, projectId?: string) =>
      appendQueryString("/api/start-page/produced-electricity/", {
        project_id: projectId,
        year
      }),
    key: (year?: number, projectId?: string) => [
      "startPage",
      "ProducedElectricity",
      { year, projectId }
    ]
  },
  electricityTax: {
    url: (year: number, projectId?: string) =>
      appendQueryString("/api/start-page/stromsteuer/", {
        project_id: projectId,
        year
      }),
    key: (year?: number, projectId?: string) => [
      "startPage",
      "electricityTax",
      { year, projectId }
    ]
  },
  eeg6: {
    url: (year: number, projectId?: string) =>
      appendQueryString("/api/start-page/paragraph-6-eeg/", {
        project_id: projectId,
        year
      }),
    key: (year?: number, projectId?: string) => [
      "startPage",
      "eeg6",
      { year, projectId }
    ]
  },
  siteSetupProcesses: {
    url: ({
      page,
      pageSize,
      projectId
    }: {
      page: number;
      pageSize: number;
      projectId?: string;
    }) =>
      appendQueryString("/api/start-page/site-setup-processes/", {
        page,
        page_size: pageSize,
        project_id: projectId
      }),
    key: ({
      page,
      pageSize,
      projectId
    }: {
      page?: number;
      pageSize?: number;
      projectId?: string;
    }) => ["startPage", "siteSetupProcesses", { page, pageSize, projectId }]
  },
  tiles: {
    url: (projectId?: string) =>
      appendQueryString("/api/start-page/tiles/", {
        project_id: projectId
      }),
    key: (projectId?: string) => ["startPage", "tiles", { projectId }]
  }
} satisfies Api;

export { startPageApi };
